import { createSelector } from "reselect";

const selectOperationsState = (state) => state.operations;

const selectOperations = () => createSelector(selectOperationsState, (operationsState) => operationsState.operations);
const selectOperationsFilter = () => createSelector(selectOperationsState, (operationsState) => operationsState.filter);


export {
    selectOperations,
    selectOperationsFilter
}